"use strict";

function _typeof(t) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
    })(t)
}
var templateUtil = {
    extractData: function(t, e) {
        for (var r = [], n = [], a = 0; a < t.length; a++) t[a][e] && !n[t[a][e]] && (n[t[a][e]] = 1, r.push(t[a][e]));
        return r
    },
    modifyColumns: function(t) {
        for (var e = Object.keys(t), r = [], n = 0; n < e.length; ++n) r.push(t[e[n]]);
        return r
    },
    convertArrayInLabelValue: function(t, e, r) {
        if (!Array.isArray(t)) return [];
        for (var n = [], a = 0; a < t.length; ++a) n.push({
            label: e,
            value: t[a],
            other: r
        });
        return n
    },
    getWidgetColumnsByOrder: function(t) {
        for (var e = [], r = Object.keys(t), n = 0; n < r.length; ++n) e.push({
            name: r[n],
            priority: t[r[n]].order ? t[r[n]].order : Number.MAX_VALUE
        });
        e.sort(function(t, e) {
            return t.priority - e.priority
        });
        for (var a = [], i = 0; i < e.length; ++i) a.push(e[i].name);
        return a
    },
    getColumnWiseData: function(t, n) {
        return Array.isArray(n) && n.length < 0 || Object.keys(n).length < 1 ? [] : t.map(function(e) {
            var r = {};
            return (Array.isArray(n) ? n : Object.keys(n)).forEach(function(t) {
                "object" === _typeof(n) && n[t] && n[t].callback && n[t].callback.body ? r[t] = new Function(n[t].callback.args ? n[t].callback.args : "", n[t].callback.body)(e[t]) : "object" === _typeof(n) && n[t] && n[t].separate_num ? r[t] = initScript.separateNumberByDelimiter(e[t]) : "object" === _typeof(n) && n[t] && n[t].format ? r[t] = initScript.dateFormat(e[t], n[t].format) : "category" === t && e[t].length < 1 ? r[t] = (e.transaction_type.toString().toLowerCase(), "Credits") : r[t] = e[t]
            }), r
        })
    },
    compileTemplate: function(t, e) {
        return Handlebars.compile(t)(e)
    },
    appendTabelHeaders: function(t) {
        for (var e = "", r = 0; r < t.table_divs.length; ++r) {
            e = "";
            for (var n = 0; n < t.table_divs[r].columns.length; ++n) {
                var a = t.table_divs[r].columns[n],
                    i = initScript.removeUnderscoreWithCamelCase(a),
                    o = t.columns && t.columns[a] && t.columns[a].config && t.columns[a].config.header ? t.columns[a].config.header : {},
                    l = initScript.hasObjectKeyProperty(t.columns || {}, a) && t.columns[a].value ? t.columns[a].value : i;
                e += initScript.bindAttrsOnHTMLTag(t.tag ? t.tag : "div", l, o)
            }
            initScript.getHTMLElementByDelimiter(t.body.class + " ." + t.table_divs[r].target.header).append(e)
        }
    },
    appendTabelRows: function(t) {
        if (t.data) {
            for (var e = 0; e < t.table_divs.length; ++e) initScript.getHTMLElementByDelimiter(t.table_divs[e].target.row).children().not(":first").remove();
            for (var r = initScript.getObjectValue(t, "rows.exclude"), n = 0; n < t.data.length; ++n)
                for (var a = 0; a < t.table_divs.length; ++a) {
                    for (var i = "", o = 0; o < t.table_divs[a].columns.length; ++o) {
                        var l = !1,
                            c = t.table_divs[a].columns[o],
                            s = initScript.getObjectValue(t, "columns." + c + ".config.row") ? t.columns[c].config.row : {},
                            m = initScript.getObjectValue(t, "columns." + c),
                            u = m ? m.callback : null;
                        u && ("odd" === r && n % 2 == 1 || "even" === r && n % 2 == 0) ? l = !0 : u && initScript.getObjectValue(t, "rows[" + n + "]") && (u.name = t.rows.callback ? t.rows.callback.name : null);
                        var p = t.data[n][c],
                            b = initScript.getObjectValue(t, "columns." + c + ".style") || initScript.getObjectValue(t, "columns." + c + ".css");
                        Object.assign(s, b ? {
                            style: b
                        } : {}), !l && u && u.name ? p = templateUtil[u.name] ? templateUtil[u.name](p) : templateEvents[u.name] ? templateEvents[u.name](p) : initScript[u.name](p) : !l && u && u.args && u.body && (p = new Function(u.args ? u.args : "", u.body)(p)), m && m.html && (p = initScript.bindAttrsOnHTMLTag(m.html.tag || "br", p, m.html.config || {})), i += initScript.bindAttrsOnHTMLTag(t.tag ? t.tag : "div", p, s)
                    }
                    t.table_divs[a].row_parent && (i = initScript.bindAttrsOnHTMLTag(t.tag ? t.tag : "div", i, t.table_divs[a].row_parent ? t.table_divs[a].row_parent : {
                        class: t.body.class + " .data-row"
                    })), initScript.getHTMLElementByDelimiter(t.table_divs[a].target.row).append(i)
                }
        }
    },
    addEmptySection: function(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "#",
            r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "No Data Found",
            n = initScript.getHTMLElementByDelimiter(t, e);
        n.addClass("empty-data-section"), n.html(r)
    },
    removeEmptySection: function(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "#";
        initScript.getHTMLElementByDelimiter(t, e).removeClass("empty-data-section")
    }
};
